import { TooltipHost } from "@fluentui/react";
import { Icon, IIconStyles } from "@fluentui/react/lib/Icon";

const tooltipCalloutProps = { gapSpace: 5 };

const infoIconStyles: Partial<IIconStyles> = {
  root: {
    cursor: 'pointer',
    color: 'var(--theme-palette-primary-light)',
    fontSize: '16px',
  }
};

type InfoTooltipProps = {
  infoContent: string;
}

export const InfoTooltip = ({ infoContent }: InfoTooltipProps) => {
  return (
    <TooltipHost
      content={infoContent}
      calloutProps={tooltipCalloutProps}
    >
      <Icon iconName="Info" styles={infoIconStyles} />
    </TooltipHost>
  );
};
